// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_01W","cls2":"ProfileDropdown-cls2_-q4 ProfileDropdown-cls1_01W"};